import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, TablePagination, Chip } from '@mui/material';

const ApprovalsSection = ({ activeMenu, pendingReqs, historyReqs, pendingWoReqs, historyWoReqs, handleApproval, shifts, team }) => {
  const [pagePendShift, setPagePendShift] = useState(0);
  const [rowsPerPagePendShift, setRowsPerPagePendShift] = useState(5);
  const [pagePendWo, setPagePendWo] = useState(0);
  const [rowsPerPagePendWo, setRowsPerPagePendWo] = useState(5);
  const [pageHist, setPageHist] = useState(0);
  const [rowsPerPageHist, setRowsPerPageHist] = useState(10);

  const getEmpDetails = (empId) => {
    const emp = team.find(t => t.emp_id === empId);
    if (emp) return { name: `${emp.first_name} ${emp.last_name}`, dept: emp.department };
    return { name: 'Unknown', dept: '--' };
  };

  const allHistory = [
    ...historyReqs.map(r => ({ ...r, reqType: 'SHIFT' })),
    ...historyWoReqs.map(r => ({ ...r, reqType: 'WEEK OFF' }))
  ].sort((a, b) => new Date(b.created_at || b.date || b.start_date) - new Date(a.created_at || a.date || a.start_date));

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        {activeMenu === 'app_pending' ? 'Pending Approvals' : 'Approval History'}
      </Typography>

      {activeMenu === 'app_pending' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {/* Pending Shifts */}
          <Paper sx={{ overflow: 'hidden' }}>
            <Box sx={{ p: 2, bgcolor: '#fff3e0', borderBottom: '1px solid #ffe0b2' }}>
              <Typography variant="subtitle1" color="warning.main">Pending Shift Changes</Typography>
            </Box>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Emp ID</TableCell>
                    <TableCell>Employee</TableCell>
                    <TableCell>Department</TableCell>
                    <TableCell>Dates</TableCell>
                    <TableCell>Target Shift</TableCell>
                    <TableCell>Reason</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingReqs.length === 0 ? <TableRow><TableCell colSpan={7} align="center">No pending shift requests.</TableCell></TableRow> : 
                    pendingReqs.slice(pagePendShift * rowsPerPagePendShift, pagePendShift * rowsPerPagePendShift + rowsPerPagePendShift).map(req => {
                      const { name, dept } = getEmpDetails(req.emp_id);
                      return (
                      <TableRow key={req.id} hover>
                        <TableCell sx={{ fontWeight: 'bold' }}>{req.emp_id}</TableCell>
                        <TableCell>{name}</TableCell>
                        <TableCell>{dept}</TableCell>
                        <TableCell>{req.start_date} to {req.end_date}</TableCell>
                        <TableCell>{shifts.find(s => s.id === req.requested_shift_id)?.shift_name}</TableCell>
                        <TableCell>{req.reason}</TableCell>
                        <TableCell sx={{ display: 'flex', gap: 1 }}>
                          <Button size="small" variant="contained" color="success" onClick={() => handleApproval(req.id, 'APPROVE', 'shift')}>Approve</Button>
                          <Button size="small" variant="contained" color="error" onClick={() => handleApproval(req.id, 'REJECT', 'shift')}>Reject</Button>
                        </TableCell>
                      </TableRow>
                    )})}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination component="div" count={pendingReqs.length} page={pagePendShift} onPageChange={(e, p) => setPagePendShift(p)} rowsPerPage={rowsPerPagePendShift} onRowsPerPageChange={(e) => { setRowsPerPagePendShift(parseInt(e.target.value, 10)); setPagePendShift(0); }} />
          </Paper>

          {/* Pending WOs */}
          <Paper sx={{ overflow: 'hidden' }}>
            <Box sx={{ p: 2, bgcolor: '#fff3e0', borderBottom: '1px solid #ffe0b2' }}>
              <Typography variant="subtitle1" color="warning.main">Pending Week Offs</Typography>
            </Box>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Emp ID</TableCell>
                    <TableCell>Employee</TableCell>
                    <TableCell>Department</TableCell>
                    <TableCell>Requested Date</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingWoReqs.length === 0 ? <TableRow><TableCell colSpan={5} align="center">No pending WO requests.</TableCell></TableRow> : 
                    pendingWoReqs.slice(pagePendWo * rowsPerPagePendWo, pagePendWo * rowsPerPagePendWo + rowsPerPagePendWo).map(req => {
                      const { name, dept } = getEmpDetails(req.emp_id);
                      return (
                      <TableRow key={`wo-${req.id}`} hover>
                        <TableCell sx={{ fontWeight: 'bold' }}>{req.emp_id}</TableCell>
                        <TableCell>{name}</TableCell>
                        <TableCell>{dept}</TableCell>
                        <TableCell>{req.date}</TableCell>
                        <TableCell sx={{ display: 'flex', gap: 1 }}>
                          <Button size="small" variant="contained" color="success" onClick={() => handleApproval(req.id, 'APPROVE', 'wo')}>Approve</Button>
                          <Button size="small" variant="contained" color="error" onClick={() => handleApproval(req.id, 'REJECT', 'wo')}>Reject</Button>
                        </TableCell>
                      </TableRow>
                    )})}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination component="div" count={pendingWoReqs.length} page={pagePendWo} onPageChange={(e, p) => setPagePendWo(p)} rowsPerPage={rowsPerPagePendWo} onRowsPerPageChange={(e) => { setRowsPerPagePendWo(parseInt(e.target.value, 10)); setPagePendWo(0); }} />
          </Paper>
        </Box>
      )}

      {activeMenu === 'app_history' && (
        <Paper sx={{ overflow: 'hidden' }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Type</TableCell>
                  <TableCell>Emp ID</TableCell>
                  <TableCell>Employee</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Dates</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allHistory.length === 0 ? <TableRow><TableCell colSpan={6} align="center">No history.</TableCell></TableRow> : 
                  allHistory.slice(pageHist * rowsPerPageHist, pageHist * rowsPerPageHist + rowsPerPageHist).map(req => {
                    const isShift = req.reqType === 'SHIFT';
                    const { name, dept } = getEmpDetails(req.emp_id);
                    return (
                    <TableRow key={`${req.reqType}-${req.id}`} hover>
                      <TableCell><Chip label={req.reqType} color={isShift ? 'primary' : 'secondary'} sx={isShift ? {} : {bgcolor: 'primary.main', color: '#fff'}} /></TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>{req.emp_id}</TableCell>
                      <TableCell>{name}</TableCell>
                      <TableCell>{dept}</TableCell>
                      <TableCell>{isShift ? `${req.start_date} to ${req.end_date}` : req.date}</TableCell>
                      <TableCell><Chip label={req.status} color={req.status === 'APPROVED' ? 'success' : 'default'} /></TableCell>
                    </TableRow>
                  )})}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination component="div" count={allHistory.length} page={pageHist} onPageChange={(e, p) => setPageHist(p)} rowsPerPage={rowsPerPageHist} onRowsPerPageChange={(e) => { setRowsPerPageHist(parseInt(e.target.value, 10)); setPageHist(0); }} />
        </Paper>
      )}
    </Box>
  );
};

export default ApprovalsSection;
